import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Contact from "../pages/contact/page";
import RehabilitationOutreach from "../pages/services/rehabilitation-outreach/page";
import EquipmentMonitoring from "../pages/services/equipment-monitoring/page";
import Renovation from "../pages/services/renovation/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/services/rehabilitation-outreach",
    element: <RehabilitationOutreach />,
  },
  {
    path: "/services/equipment-monitoring",
    element: <EquipmentMonitoring />,
  },
  {
    path: "/services/renovation",
    element: <Renovation />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;